export default __webpack_public_path__ + "static/media/influencer-3.a500caf3.webp";